module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Bold.62d4d7d3.otf";